__turbopack_context__.v({
  "applyButton": "FilterDropdown-module__i4hFba__applyButton",
  "badge": "FilterDropdown-module__i4hFba__badge",
  "checkboxLabel": "FilterDropdown-module__i4hFba__checkboxLabel",
  "checkboxList": "FilterDropdown-module__i4hFba__checkboxList",
  "dropdown": "FilterDropdown-module__i4hFba__dropdown",
  "dropdownBody": "FilterDropdown-module__i4hFba__dropdownBody",
  "dropdownFooter": "FilterDropdown-module__i4hFba__dropdownFooter",
  "overlay": "FilterDropdown-module__i4hFba__overlay",
  "radioLabel": "FilterDropdown-module__i4hFba__radioLabel",
  "radioList": "FilterDropdown-module__i4hFba__radioList",
  "resetButton": "FilterDropdown-module__i4hFba__resetButton",
  "sectionTitle": "FilterDropdown-module__i4hFba__sectionTitle",
  "slideDown": "FilterDropdown-module__i4hFba__slideDown",
  "trigger": "FilterDropdown-module__i4hFba__trigger",
  "wrapper": "FilterDropdown-module__i4hFba__wrapper",
});
